<template>
  <div>
    <a-drawer
      width="95%"
      max-width="1700px"
      :visible="showCreateForm"
      :body-style="{ paddingBottom: '15px', paddingTop: '15px'}"
      class="create-project-page"
      @close="close"
      :maskClosable="false"
    >
      <a-form-model ref="form" :model="model" :rules="rules" >
        <a-spin :spinning="loading" tip="Loading..." size="large" />

        <!-- 隐藏步骤导航 -->
        <a-steps type="navigation" size="small" :current="current" v-show="false">
          <a-step v-for="item in steps" :key="item.title" :title="item.title" />
        </a-steps>

        <a-form-model-item label="广告主" prop="ids">
          <adv-select v-model="model.ids" :max-tag-count="3" :type="media" @blur="changeAdvs" :disabled="current === 0 ? false : true"/>
        </a-form-model-item>

        <a-form-model-item label="所属小组" prop="team_id" v-if="adminTeams.length > 1" help="登录账号存在多小组时，需选择该任务所属小组！">
            <a-select show-search allow-clear placeholder="请选择" v-model="model.team_id" option-filter-prop="children">
              <a-select-option :value="item.id" v-for="item in adminTeams" :key="item.id" >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        
        <!-- 所有内容平铺容器 -->
        <div class="steps-container">
          <!-- 步骤1内容：全部平铺展示 -->
          <div class="step">
            <!-- ====================== 以下为【隐藏默认提交】的表单项 ====================== -->
            <!-- 推广目的 -->
            <a-form-model-item label="推广目的" prop="landing_type" v-show="false">
              <a-radio-group v-model="model.landing_type">
                <a-radio-button value="MICRO_GAME">小程序</a-radio-button>
                <a-radio-button value="QUICK_APP" :disabled="true">快应用</a-radio-button>
                <a-radio-button value="APP" :disabled="true">应用推广</a-radio-button>
              </a-radio-group>
            </a-form-model-item>

            <!-- 投放模式 -->
            <a-form-model-item label="投放模式" prop="delivery_mode">
              <a-radio-group v-model="model.delivery_mode" @change="changeDeliveryMode">
                <a-radio-button value="MANUAL">手动</a-radio-button>
                <a-radio-button value="PROCEDURAL" >自动</a-radio-button>
              </a-radio-group>
            </a-form-model-item>

            <!-- 营销场景 -->
            <a-form-model-item label="营销场景" prop="marketing_goal" v-show="false">
              <a-radio-group v-model="model.marketing_goal">
                <a-radio-button value="VIDEO_AND_IMAGE">短视频+图文</a-radio-button>
                <a-radio-button value="LIVE" :disabled="true">直播</a-radio-button>
              </a-radio-group>
            </a-form-model-item>

            <!-- 广告类型 -->
            <a-form-model-item label="广告类型" prop="ad_type" v-show="false">
              <a-radio-group v-model="model.ad_type">
                <a-radio-button value="ALL">通投广告</a-radio-button>
                <a-radio-button value="SEARCH" :disabled="true">搜索广告</a-radio-button>
              </a-radio-group>
            </a-form-model-item>

            <!-- 投放内容 -->
            <a-form-model-item label="投放内容" prop="micro_promotion_type">
              <a-radio-group v-model="model.micro_promotion_type" @change="changeMicroPromotionType" disabled>
                <a-radio-button value="WECHAT_APP">微信小程序</a-radio-button>
                <a-radio-button value="BYTE_APP">字节小程序</a-radio-button>
                <a-radio-button value="AWEME">抖音号</a-radio-button>
              </a-radio-group>
            </a-form-model-item>

            <!-- 是否开启商品库 -->
            <a-form-model-item label="是否开启商品库" prop="need_product" v-show="false">
              <a-radio-group :default-value="1" button-style="solid" v-model="model.need_product">
                <a-radio-button :value="1">开启</a-radio-button>
                <a-radio-button :value="2">关闭</a-radio-button>
              </a-radio-group>
            </a-form-model-item>

            <!-- 投放位置 -->
            <a-form-model-item label="投放位置" prop="delivery_range.inventory_catalog" v-show="false">
              <a-radio-group v-model="model.delivery_range.inventory_catalog">
                <a-radio-button value="UNIVERSAL_SMART" :disabled="true">通投智选</a-radio-button>
                <a-radio-button value="MANUAL">首选媒体</a-radio-button>
              </a-radio-group>
              <div class="mt-10"></div>
              <a-select show-search allow-clear  mode="multiple" placeholder="媒体选择" v-model="model.delivery_range.inventory_type" option-filter-prop="children" :disabled="showInventoryType">
                <a-select-option :value="type.id" v-for="type in inventoryTypes" :key="type.id" :disabled="type.disabled">
                  {{ type.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <!-- 地域 -->
            <a-form-model-item label="地域" prop="audience.district" v-show="false">
              <a-radio-group v-model="model.audience.district">
                <a-radio-button value="NONE">不限</a-radio-button>
                <a-radio-button value="REGION">除北上广深</a-radio-button>
              </a-radio-group>
            </a-form-model-item>

            <!-- 性别 -->
            <a-form-model-item label="性别" prop="audience.gender" v-show="false">
              <a-radio-group v-model="model.audience.gender">
                <a-radio-button value="NONE">不限</a-radio-button>
                <a-radio-button value="GENDER_MALE">男</a-radio-button>
                <a-radio-button value="GENDER_FEMALE">女</a-radio-button>
              </a-radio-group>
            </a-form-model-item>

            <!-- 年龄 -->
            <a-form-model-item label="年龄" prop="audience.age" v-show="false">
              <a-checkbox-group v-model="model.audience.age" @change="changeAge">
                <a-checkbox name="age" :value="age.id" v-for="age in ages" :key="age.id">
                  {{ age.name }}
                </a-checkbox>
              </a-checkbox-group>
            </a-form-model-item>

            <!-- 平台 -->
            <a-form-model-item label="平台" prop="audience.platform" v-show="false">
              <a-checkbox-group v-model="model.audience.platform" @change="changePlatform">
                <a-checkbox name="platform" :value="platform.id" v-for="platform in platforms" :key="platform.id">
                  {{ platform.name }}
                </a-checkbox>
              </a-checkbox-group>
            </a-form-model-item>

            <!-- 行为兴趣 -->
            <a-form-model-item label="行为兴趣" prop="audience.interest_action_mode" v-if="model.delivery_mode == 'MANUAL'" v-show="false">
              <a-radio-group v-model="model.audience.interest_action_mode">
                <a-radio-button value="UNLIMITED">不限</a-radio-button>
                <a-radio-button value="RECOMMEND">系统推荐</a-radio-button>
              </a-radio-group>
            </a-form-model-item>

            <!-- 投放时间 -->
            <a-form-model-item label="投放时间" prop="delivery_setting.schedule_type" v-show="false">
              <a-radio-group v-model="model.delivery_setting.schedule_type">
                <a-radio-button value="SCHEDULE_FROM_NOW">从今天起长期投放</a-radio-button>
                <a-radio-button value="SCHEDULE_START_END">设置开始和结束日期</a-radio-button>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="" prop="delivery_setting.schedule_type" v-if="model.delivery_setting.schedule_type=='SCHEDULE_START_END'" v-show="false">
                <a-range-picker  v-model="model.delivery_setting.schedule_date" valueFormat="YYYY-MM-DD" :disabled-date="disabledDate"/>
            </a-form-model-item>

            <!-- 投放时段 -->
            <a-form-model-item label="投放时段" prop="delivery_setting.schedule_time_type" v-show="false">
              <a-radio-group v-model="model.delivery_setting.schedule_time_type">
                <a-radio-button :value="1">不限</a-radio-button>
                <a-radio-button :value="2">指定时间段</a-radio-button>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="" prop="delivery_setting.schedule_time" v-if="model.delivery_setting.schedule_time_type==2" v-show="false">
              <byted-schedule v-model="model.delivery_setting.schedule_time" show-checkbox>
                <span slot="header"></span>
              </byted-schedule>
            </a-form-model-item>

            <!-- 定向扩展 -->
            <a-form-model-item label="定向扩展" prop="audience_extend" v-show="false">
              <a-radio-group v-model="model.audience_extend">
                <a-radio-button value="OFF">不启用</a-radio-button>
                <a-radio-button value="ON">启用</a-radio-button>
              </a-radio-group>
            </a-form-model-item>
            <!-- ====================== 隐藏项结束 ====================== -->

            <!-- 以下为【保留展示】的核心表单项 -->
            <a-form-model-item label="优化目标" prop="optimize_goal.external_action">
              <a-select show-search placeholder="请选择" v-model="model.optimize_goal.external_action" option-filter-prop="children" @change="changeExternalAction">
                <a-select-option :value="type.id" v-for="type in promotionTypes" :key="type.id" :disabled="type.disabled || (mediaCorporationCheck(1) && type.id != 'AD_CONVERT_TYPE_PAY') || (mediaCorporationCheck(2) && type.id == 'AD_CONVERT_TYPE_PAY') "  >
                  {{ type.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <template >
              <a-form-model-item  label="深度优化目标" prop="optimize_goal.deep_external_action" v-if="['AD_CONVERT_TYPE_PAY', 'AD_CONVERT_TYPE_ACTIVE'].includes(model.optimize_goal.external_action)">
                <a-select @change="changeDeepExternalAction" show-search allow-clear placeholder="请选择" v-model="model.optimize_goal.deep_external_action" option-filter-prop="children">
                  <a-select-option :value="type.id" v-for="type in deepPromotionTypes" :key="type.id" :disabled="!((model.optimize_goal.external_action === 'AD_CONVERT_TYPE_PAY' && type.id==='AD_CONVERT_TYPE_PURCHASE_ROI') || (model.optimize_goal.external_action === 'AD_CONVERT_TYPE_ACTIVE' && type.id==='AD_CONVERT_TYPE_LT_ROI' ) )">
                    {{ type.name }} 
                  </a-select-option>
                </a-select>
              </a-form-model-item>

              <a-form-model-item label="深度优化方式" prop="delivery_setting.deep_bid_type" v-if="model.optimize_goal.deep_external_action">
                <a-radio-group v-model="model.delivery_setting.deep_bid_type">
                  <a-radio-button value="ROI_COEFFICIENT">ROI系数</a-radio-button>
                </a-radio-group>
              </a-form-model-item>
            </template>

            <a-form-model-item label="竞价策略" prop="delivery_setting.bid_type">
              <a-radio-group v-model="model.delivery_setting.bid_type" @change="changeBidType" v-if="model.delivery_mode === 'PROCEDURAL'">
                <a-radio-button :value="type.id" v-for="type in bidTypes2" :key="type.id">{{ type.name }}</a-radio-button>
              </a-radio-group>
              <a-radio-group v-model="model.delivery_setting.bid_type" @change="changeBidType" v-else>
                <a-radio-button :value="type.id" v-for="type in bidTypes" :key="type.id">{{ type.name }}</a-radio-button>
              </a-radio-group>
            </a-form-model-item>

            <a-form-model-item label="择优分配" prop="delivery_setting.budget_optimize_switch" v-if="model.delivery_setting.bid_type === 'NO_BID'">
              <a-radio-group v-model="model.delivery_setting.budget_optimize_switch">
                <a-radio-button value="OFF">不启用</a-radio-button>
                <a-radio-button value="ON">启用</a-radio-button>
              </a-radio-group>
            </a-form-model-item>

            <a-form-model-item label="项目日预算" prop="delivery_setting.budget_mode" v-if="model.delivery_mode === 'PROCEDURAL'">
              <a-input-number
                    v-model="model.delivery_setting.budget"
                    :placeholder="`请输入预算，不少于${model.delivery_mode === 'PROCEDURAL' ? 100 : 300}元`+ (model.delivery_setting.bid_type === 'NO_BID' ? '，上限500': '')"
                    addon-after="元"
                    :max="model.delivery_setting.bid_type === 'NO_BID'  ? 500 : 9999999"
                />
            </a-form-model-item>

            <a-form-model-item label="项目预算" prop="delivery_setting.budget_mode" v-else>
              <a-radio-group v-model="model.delivery_setting.budget_mode">
                <a-radio-button
                  value="BUDGET_MODE_INFINITE"
                  :disabled="model.delivery_setting.budget_optimize_switch === 'ON' && model.delivery_setting.bid_type === 'NO_BID'"
                >
                  不限
                </a-radio-button>
                <a-radio-button value="BUDGET_MODE_DAY">设置预算</a-radio-button>
              </a-radio-group>

              <div class="mt-10">
                <a-input-number
                    v-model="model.delivery_setting.budget"
                    :placeholder="'请输入预算，不少于300元'+ (model.delivery_setting.bid_type === 'NO_BID' && model.delivery_setting.budget_optimize_switch ==='ON' ? '，上限500': '')"
                    addon-after="元"
                    :max="model.delivery_setting.bid_type === 'NO_BID' && model.delivery_setting.budget_optimize_switch ==='ON' ? 500 : 9999999"
                    v-if="model.delivery_setting.budget_mode === 'BUDGET_MODE_DAY'"
                />
              </div>
            </a-form-model-item>

            <a-form-model-item label="付费方式" prop="delivery_setting.pricing">
              <a-radio-group v-model="model.delivery_setting.pricing">
                <a-radio-button value="PRICING_OCPM">按展示付费(oCPM)</a-radio-button>
              </a-radio-group>
            </a-form-model-item>

            <template v-if="model.delivery_mode === 'PROCEDURAL'">
              <div v-if="model.delivery_setting.bid_type != 'NO_BID' && !(model.optimize_goal.external_action === 'AD_CONVERT_TYPE_ACTIVE' && model.optimize_goal.deep_external_action==='AD_CONVERT_TYPE_LT_ROI')">
                <a-form-model-item label="出价模式" prop="cpa_bid_model">
                  <a-radio-group v-model="model.cpa_bid_model">
                    <a-radio-button :value="1" >统一设置</a-radio-button>
                    <a-radio-button :value="2" >分别设置</a-radio-button>
                  </a-radio-group>
                </a-form-model-item>
                <template v-if="model.cpa_bid_model === 1">
                  <a-form-model-item prop="cpa_bid" label="出价" :help="'项目出价，不少于0.01元，不超过'+(bid_limit ? bid_limit : 10+'元'+remind)">
                    <a-input-number :min="0.01" :max="bid_limit ? bid_limit : 10" :precision="2" v-model="model.cpa_bid" />
                  </a-form-model-item>
                </template>
                <template v-else>
                  <a-form-model-item label=""  help='' style="border: 1px solid #87e8de;;padding:20px">
                    <div style="margin-bottom: 10px; text-align: right;">
                      <a-button type="primary" @click="setBatchCpaBid">一键设置出价</a-button>
                      <div style="margin-top: 5px; color: orange; font-size: 12px;">
                        一键设置出价：系统默认设置所选广告主的限制出价自动填充；反之，则不填充。
                      </div>
                    </div>
                    <a-tabs :default-active-key="0" size="small" tabPosition="left" :style="{ height: '300px' }">
                      <a-tab-pane v-for="(advertiser,index) in advertisers" :key="index" :tab="renderTab(advertiser, 'cpa_bid')">
                        <a-form-model-item label="出价" :help="'项目出价，不少于0.01元，不超过'+(advertiser.bid_limit ? advertiser.bid_limit : 10+'元'+remind)">
                          <a-input-number :min="0.01" :max="advertiser.bid_limit ? advertiser.bid_limit : 10" :precision="2" v-model="advertisers[index].cpa_bid" />
                        </a-form-model-item>
                      </a-tab-pane>
                    </a-tabs>
                  </a-form-model-item>
                </template>
              </div>

              <div v-if="model.delivery_setting.bid_type != 'NO_BID' && model.optimize_goal.deep_external_action">
                <a-form-model-item label="ROI系数模式" prop="roi_goal_model">
                  <a-radio-group v-model="model.roi_goal_model">
                    <a-radio-button :value="1" >统一设置</a-radio-button>
                    <a-radio-button :value="2" >分别设置</a-radio-button>
                  </a-radio-group>
                </a-form-model-item>

                <template v-if="model.roi_goal_model === 1">
                  <a-form-model-item prop="roi_goal" label="ROI系数" :help="`ROI系数，大于${getRoiMin()}，不超过5`">
                    <a-input-number :min="getRoiMin()" :max="5" :precision="4" v-model="model.roi_goal" />
                  </a-form-model-item>
                </template>
                <template v-else>
                  <a-form-model-item label=""  help='' style="border: 1px solid #87e8de;;padding:20px">
                    <a-tabs :default-active-key="0" size="small" tabPosition="left" :style="{ height: '300px' }">
                      <a-tab-pane v-for="(advertiser,index) in advertisers" :key="index" :tab="renderTab(advertiser, 'roi_goal')">
                        <a-form-model-item label="ROI系数" :help="`ROI系数，大于${getRoiMin()}，不超过5`">
                          <a-input-number :min="getRoiMin(advertiser)" :max="5" :precision="4" v-model="advertisers[index].roi_goal" />
                        </a-form-model-item>
                      </a-tab-pane>
                    </a-tabs>
                  </a-form-model-item>
                </template>
              </div>
            </template>
      
            <a-form-model-item v-else prop="search_bid_ratio" label="出价系数" help="推荐出价系数 1.05，预估跑量可提升10%-20%">
              <a-input-number :min="1" :max="2" :precision="2" v-model="model.search_bid_ratio" :disabled="model.delivery_setting.bid_type === 'NO_BID'" />
            </a-form-model-item>

            <a-form-model-item label="项目名称模式" prop="project_name_model">
              <a-radio-group v-model="model.project_name_model">
                <a-radio-button :value="1" >统一设置</a-radio-button>
                <a-radio-button :value="2" >分别设置</a-radio-button>
              </a-radio-group>
            </a-form-model-item>

            <template v-if="model.project_name_model === 1">
              <a-form-model-item prop="name" label="项目名称">
                <a-input v-model="model.name"  />
              </a-form-model-item>
            </template>
            <template v-else>
              <a-form-model-item label=""  help='' style="border: 1px solid #87e8de;;padding:20px">
                <a-tabs :default-active-key="0" size="small" tabPosition="left" :style="{ height: '300px' }">
                  <a-tab-pane v-for="(advertiser,index) in advertisers" :key="index" :tab="renderTab(advertiser, 'project_name')">
                    <a-form-model-item label="项目名称" help="">
                      <a-input v-model="advertisers[index].project_name"  />
                    </a-form-model-item>
                  </a-tab-pane>
                </a-tabs>
              </a-form-model-item>
            </template>
            

            <a-form-model-item label="项目状态" prop="operation">
              <a-radio-group v-model="model.operation">
                <a-radio-button value="ENABLE">开启</a-radio-button>
                <a-radio-button value="DISABLE">关闭</a-radio-button>
              </a-radio-group>
            </a-form-model-item>
          </div>

          <!-- 步骤2内容：平铺展示 -->
          <div class="step">
            <a-form-model-item label="抖音号" prop="ad.native_setting.aweme_id">
              <a-select
                mode="multiple"
                show-search
                allow-clear
                placeholder="请选择"
                v-model="model.ad.native_setting.aweme_id"
                option-filter-prop="children"
                @change="handleChange"
              >
                <a-select-option key="all" value="all">
                  <a-icon 
                    :type="'check-circle'" 
                    style="color: #1890ff; margin-right: 8px" 
                  />
                  <span style="font-weight: 600">全选</span>
                </a-select-option>
                <a-select-option :value="aweme.id" v-for="aweme in awemes" :key="aweme.id">
                  {{ aweme.name }}
                </a-select-option>
              </a-select>
              <div v-if="Array.isArray(model.ad.native_setting.aweme_id) && model.ad.native_setting.aweme_id.length > 1" style="margin-top: 8px;">
                <a-switch v-model="model.ad.generate_mode" @change="handleGenerateModeChange" />
                <span style="margin-left: 8px; font-weight: 500;">启用生成模式</span>
                <div style="margin-top: 4px; color: #999; font-size: 13px;">
                  开启后，系统会根据所选抖音号自动生成组合内容，避免逐个配置，提升效率。
                </div>
              </div>
            </a-form-model-item>

            <!-- 设置主页可见性：隐藏 -->
            <a-form-model-item label="设置主页可见性" prop="ad.video_hp_visibility">
              <a-radio-group  v-model="model.ad.video_hp_visibility" >
                <a-radio-button value="ALWAYS_VISIBLE">主页始终可见</a-radio-button>
                <a-radio-button value="HIDE_VIDEO_ON_HP">仅单次展示可见</a-radio-button>
              </a-radio-group>
            </a-form-model-item>
           
            <a-tabs :default-active-key="material_type" @change="materialTypeChange">
              <a-tab-pane :key="1" tab="账户素材">
                <template v-if="material_type==1">
                  <a-form-model-item prop="ad.video_ids" label="广告素材" help="所选素材将随机平均分配至广告列表">
                    <div style="display: flex; align-items: center;">
                      <a-select placeholder="选择广告主" v-model="currentAdvId" @change="changeAdvertiser" show-search option-filter-prop="children" style="width: 220px; margin-right: 10px;">
                          <a-select-option :value="item.id" v-for="item in advertisers" :key="item.id" >
                              {{ item.name }}
                          </a-select-option>
                      </a-select>
                      <video-select
                        v-model="model.ad.video_ids"
                        :max-num="model.ad.num * (model.delivery_mode === 'PROCEDURAL' ? 30 : 10)"
                        :advertiser-id="currentAdvId"
                        :media="media"
                        v-if="currentAdvId > 0"
                      />
                    </div>
                  </a-form-model-item>
                </template>
              </a-tab-pane>
              <a-tab-pane :key="2" tab="本地素材库" force-render>
                <div class="local-material-scroll">
                  <template v-if="material_type==2">
                  <a-form-model-item prop="ad.video_ids_local" label="广告素材" help="所选素材将随机平均分配至广告列表">
                    <!-- :filters="{ type: 3, num: model.ad.num * (model.delivery_mode === 'PROCEDURAL' ? 30 : 10), isBatchSelect:true, need_sync_juliang_or_organize:true, from_local_select: true}" -->
                    <material-select
                      v-model="model.ad.video_ids_local"
                      :filters="{ type: 3, num: model.ad.num * (model.delivery_mode === 'PROCEDURAL' ? 30 : 10), isBatchSelect:true, need_sync_juliang_or_organize:true, from_local_select: true}"
                      :returnData="model.ad.video_ids_local"
                      @change="changeVideo"
                      :simpleMode=true
                    />
                 </a-form-model-item>
                </template>
                </div>
              </a-tab-pane>
              <a-tab-pane :key="3" tab="素材排行">
                <template v-if="material_type==3">
                  <a-form-model-item prop="ad.video_ids_rank" label="广告素材" help="所选素材将随机平均分配至广告列表">
                    <video-rank-select
                      v-model="model.ad.video_ids_rank"
                      :max-num="model.ad.num * (model.delivery_mode === 'PROCEDURAL' ? 30 : 10)"
                      :media="media"
                      :filter=true
                    />
                  </a-form-model-item>
                </template>
              </a-tab-pane>
              <a-tab-pane :key="4" tab="组织素材" v-if="media === 'juliang'">
                <template v-if="material_type==4">
                  <a-form-model-item prop="ad.video_ids_org" label="广告素材" help="所选素材将随机平均分配至广告列表">
                    <div style="display: flex; align-items: center;">
                      <a-select placeholder="选择广告主" v-model="currentAdvId" @change="changeAdvertiser" show-search option-filter-prop="children" style="width: 220px; margin-right: 10px;">
                          <a-select-option :value="item.id" v-for="item in advertisers" :key="item.id" >
                              {{ item.name }}
                          </a-select-option>
                      </a-select>
                      <org-video-select
                        v-model="model.ad.video_ids_org"
                        :max-num="model.ad.num * (model.delivery_mode === 'PROCEDURAL' ? 30 : 10)"
                        :advertiser-id="currentAdvId"
                        :media="media"
                        v-if="currentAdvId > 0"
                      />
                    </div>
                  </a-form-model-item>
                </template>
              </a-tab-pane>
            </a-tabs>

            <a-form-model-item label="文案素材标题" prop="ad.promotion_materials.title_material_list">
              <code-input ref="title_group" class="title-group" v-model="model.ad.promotion_materials.title_material_list"  />
              <div>
                <span>多个标题可按回车分隔，也可以批量导入 </span>
                <a-button type="primary" @click="showModal">
                  本地文案库
                </a-button>
              </div>
            </a-form-model-item>
         
            <!-- 原生锚点：隐藏 -->
            <a-form-model-item v-if="model.micro_promotion_type === 'BYTE_APP'" label="原生锚点" prop="ad.native_setting.anchor_related_type" v-show="false">
              <a-radio-group  v-model="model.ad.native_setting.anchor_related_type" >
                <a-radio-button value="OFF">不启用</a-radio-button>
                <a-radio-button value="AUTO">自动生成</a-radio-button>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item v-if="model.micro_promotion_type != 'BYTE_APP'" label="原生锚点" prop="ad.native_setting.anchor_related_type" v-show="false">
              <a-radio-group  v-model="model.ad.native_setting.anchor_related_type" >
                <a-radio-button value="AUTO">自动生成</a-radio-button>
                <a-radio-button value="SELECT">手动选择</a-radio-button>
              </a-radio-group>
            </a-form-model-item>

            <a-form-model-item label="产品名称" prop="ad.promotion_materials.product_info.titles">
              <a-auto-complete :data-source="product_titles" v-model="model.ad.promotion_materials.product_info.titles" />
            </a-form-model-item>

            <a-form-model-item label="产品主图" prop="ad.promotion_materials.product_info.image">
              <material-select
                v-model="model.ad.promotion_materials.product_info.image"
                :filters="{ type: 2, num: 1, width: 108, height: 108, size: 5 }"
                @delete="deleteImage"
              />
            </a-form-model-item>

            <a-form-model-item label="产品卖点" prop="ad.promotion_materials.product_info.selling_points" help="">
              <a-select
                mode="tags"
                show-search
                allow-clear
                placeholder="请选择"
                v-model="model.ad.promotion_materials.product_info.selling_points"
                option-filter-prop="children"
              >
                <a-select-option :value="item" v-for="item in sellingPoints" :key="item">
                  {{ item }}
                </a-select-option>
              </a-select> 
            </a-form-model-item>

            <a-form-model-item label="行动号召" prop="ad.promotion_materials.call_to_action_buttons">
              <a-select
                mode="tags"
                show-search
                allow-clear
                placeholder="请选择"
                v-model="model.ad.promotion_materials.call_to_action_buttons"
                option-filter-prop="children"
              >
                <a-select-option :value="button" v-for="button in buttons" :key="button">
                  {{ button }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <div v-show="true">
              <a-form-model-item label="来源模式" prop="ad.source_model">
                <a-radio-group v-model="model.ad.source_model">
                  <a-radio-button :value="1" >统一设置</a-radio-button>
                  <a-radio-button :value="2" >分别设置</a-radio-button>
                </a-radio-group>
              </a-form-model-item>

              <template v-if="model.ad.source_model === 1">
                <a-form-model-item label="来源" prop="ad.source" help="需填写广告主公司名称或者品牌名称中具有代表性的核心词汇">
                  <a-auto-complete :data-source="sources" v-model="model.ad.source" />
                </a-form-model-item>
              </template>
              <template v-else>
                <a-form-model-item label=""  help='' style="border: 1px solid #87e8de;;padding:20px">
                  <div style="margin-bottom: 10px; text-align: right;">
                    <a-button type="primary" @click="setBatchSource">一键设置来源</a-button>
                  </div>
                  <a-tabs :default-active-key="0" size="small" tabPosition="left" :style="{ height: '300px' }">
                    <a-tab-pane v-for="(advertiser,index) in advertisers" :key="index" :tab="renderTab(advertiser, 'source')">
                      <a-form-model-item label="来源" help="需填写广告主公司名称或者品牌名称中具有代表性的核心词汇">
                        <a-auto-complete :data-source="sources" v-model="advertisers[index].ad.source" />
                      </a-form-model-item>
                    </a-tab-pane>
                  </a-tabs>
                </a-form-model-item>
              </template>
            </div>

            <!-- 广告评论：隐藏 -->
            <a-form-model-item label="广告评论" prop="ad.is_comment_disable" v-show="false">
              <a-radio-group v-model="model.ad.is_comment_disable">
                <a-radio-button value="OFF">不启用</a-radio-button>
                <a-radio-button value="ON">启用</a-radio-button>
              </a-radio-group>
            </a-form-model-item>

            <template v-if="model.delivery_mode != 'PROCEDURAL'">
              <a-form-model-item prop="ad.budget" label="预算" :help="'请输入预算，不少于'+adBudget+'元'+ (model.delivery_setting.bid_type === 'NO_BID' && model.delivery_setting.budget_optimize_switch ==='OFF' ? '，上限500' : '')" v-if="showAdBudge">
                <a-input-number 
                    v-model="model.ad.budget" 
                    :min="adBudget" addon-after="元" 
                    :max="model.delivery_setting.bid_type === 'NO_BID' && model.delivery_setting.budget_optimize_switch ==='OFF' ? 500 : 999999"
                />
              </a-form-model-item>

              <div v-if="showAdBid && !(model.optimize_goal.external_action == 'AD_CONVERT_TYPE_ACTIVE' && model.optimize_goal.deep_external_action == 'AD_CONVERT_TYPE_LT_ROI')">
                <a-form-model-item label="广告出价模式" prop="ad.bid_model">
                  <a-radio-group v-model="model.ad.bid_model">
                    <a-radio-button :value="1" >统一设置</a-radio-button>
                    <a-radio-button :value="2" >分别设置</a-radio-button>
                  </a-radio-group>
                </a-form-model-item>

                <template v-if="model.ad.bid_model === 1">
                  <a-form-model-item prop="ad.bid" label="广告出价" :help="(bid_suggest ? '该主体建议出价：'+bid_suggest+'，' : '')+'限制出价：'+ (bid_limit ? bid_limit : 10+remind)">
                    <a-input-number :min="0.01" :max="bid_limit ? bid_limit : 10" :placeholder="bid_suggest ? '该主体建议出价：'+bid_suggest : ''" :precision="2" v-model="model.ad.bid" addon-after="元" />
                  </a-form-model-item>
                </template>
                <template v-else>
                  <a-form-model-item label=""  help='' style="border: 1px solid #87e8de;;padding:20px">
                    <div style="margin-bottom: 10px; text-align: right;">
                      <a-button type="primary" @click="setBatchBid">一键设置出价</a-button>
                    </div>
                    <a-tabs :default-active-key="0" size="small" tabPosition="left" :style="{ height: '300px' }">
                      <a-tab-pane v-for="(advertiser,index) in advertisers" :key="index" :tab="renderTab(advertiser, 'ad_bid')">
                        <a-form-model-item label="广告出价" :help="(advertiser.bid_suggest ? '该主体建议出价：'+advertiser.bid_suggest+'，' : '')+'限制出价：'+ (advertiser.bid_limit ? advertiser.bid_limit : 10+remind)">
                          <a-input-number :min="0.01" :max="advertiser.bid_limit ? advertiser.bid_limit : 10" :placeholder="advertiser.bid_suggest ? '该主体建议出价：'+advertiser.bid_suggest : ''" :precision="2" v-model="advertisers[index].bid" addon-after="元" />
                        </a-form-model-item>
                      </a-tab-pane>
                    </a-tabs>
                  </a-form-model-item>
                </template>
              </div>
              
              <div v-if="model.delivery_setting.bid_type != 'NO_BID' && ( (model.optimize_goal.external_action === 'AD_CONVERT_TYPE_PAY' && model.optimize_goal.deep_external_action == 'AD_CONVERT_TYPE_PURCHASE_ROI') || (model.optimize_goal.external_action == 'AD_CONVERT_TYPE_ACTIVE' && model.optimize_goal.deep_external_action == 'AD_CONVERT_TYPE_LT_ROI'))">
                <a-form-model-item label="ROI系数模式" prop="ad.roi_goal_model">
                  <a-radio-group v-model="model.ad.roi_goal_model">
                    <a-radio-button :value="1" >统一设置</a-radio-button>
                    <a-radio-button :value="2" >分别设置</a-radio-button>
                  </a-radio-group>
                </a-form-model-item>

                <template v-if="model.ad.roi_goal_model === 1">
                  <a-form-model-item prop="ad.roi_goal" label="ROI系数" :help="`ROI系数，大于${getRoiMin()}，不超过5`">
                    <a-input-number :min="getRoiMin()" :max="5" :precision="4" v-model="model.ad.roi_goal" />
                  </a-form-model-item>
                </template>
                <template v-else>
                  <a-form-model-item label=""  help='' style="border: 1px solid #87e8de;;padding:20px">
                    <a-tabs :default-active-key="0" size="small" tabPosition="left" :style="{ height: '300px' }">
                      <a-tab-pane v-for="(advertiser,index) in advertisers" :key="index" :tab="renderTab(advertiser, 'ad_roi_goal')">
                        <a-form-model-item label="ROI系数" :help="`ROI系数，大于${getRoiMin()}，不超过5`">
                          <a-input-number :min="getRoiMin(advertiser)" :max="5" :precision="4" v-model="advertisers[index].ad.roi_goal" />
                        </a-form-model-item>
                      </a-tab-pane>
                    </a-tabs>
                  </a-form-model-item>
                </template>
              </div>
            </template>
        
            <!-- 广告名称模式：隐藏 -->
            <div v-show="false">
              <a-form-model-item label="广告名称模式" prop="ad.ad_name_model">
                <a-radio-group v-model="model.ad.ad_name_model">
                  <a-radio-button :value="1" >统一设置</a-radio-button>
                  <a-radio-button :value="2" >分别设置</a-radio-button>
                </a-radio-group>
              </a-form-model-item>
              <!-- 广告名称：隐藏 -->
              <template v-if="model.ad.ad_name_model === 1">
                <a-form-model-item prop="ad.name" label="广告名称">
                  <a-input v-model="model.ad.name" />
                </a-form-model-item>
              </template>
              <template v-else>
                <a-form-model-item label="" help="" style="border: 1px solid #87e8de; padding:20px">
                  <a-tabs :default-active-key="'0'" size="small" tabPosition="left" :style="{ height: '300px' }">
                    <a-tab-pane v-for="(advertiser,index) in advertisers" :key="index" :tab="renderTab(advertiser, 'ad_name')">
                      <a-form-model-item label="广告名称" help="">
                        <a-input v-model="advertisers[index].ad.ad_name" />
                      </a-form-model-item>
                    </a-tab-pane>
                  </a-tabs>
                </a-form-model-item>
              </template>
            </div>

            <a-form-model-item prop="ad.num" label="广告数量" :help="adNumHelp">
              <a-input-number :min="1" :max="maxAdNum" :precision="0" v-model="model.ad.num" />
            </a-form-model-item>

            <a-form-model-item prop="ad.title_num" label="广告文案标题数量" help="每个广告的文案标题数量，最大不能超过10个">
              <a-input-number :min="1" :max="10" :precision="0" v-model="model.ad.title_num" />
            </a-form-model-item>

            <a-form-model-item label="素材分配规则" prop="ad.material_rule">
              <a-radio-group v-model="model.ad.material_rule">
                <a-radio-button :value="1">平均分配</a-radio-button>
                <a-radio-button :value="2">自定义</a-radio-button>
              </a-radio-group>
            </a-form-model-item>

            <a-form-model-item prop="ad.material_num" label="广告素材数量" help="每个广告的素材数量" v-if="model.ad.material_rule == 2">
              <a-input-number :min="1" :precision="0" v-model="model.ad.material_num" />
            </a-form-model-item>
          </div>

          <!-- 步骤3内容：平铺展示 -->
          <div class="step">
            <a-form-model-item label="批量设置备用网页链接(落地页)" v-if="model.micro_promotion_type === 'BYTE_APP'">
              <a-auto-complete
                :dropdown-match-select-width="false"
                placeholder="请选择或输入"
                option-label-prop="value"
                v-model="batch_external_url"
                >
                <template slot="dataSource">
                  <a-select-option 
                    v-for="url in externalUrls" :key="url" :value="url"  >
                    {{ url }}
                  </a-select-option>
                </template>
              </a-auto-complete>
              <div>
                <span>可自定义链接，点击一键同步按钮，会自动将下面广告主【备用网页链接(落地页)】选项填充。</span>
                <a-button type="primary" size="small" @click="syncUrls">
                  一键同步
                </a-button>
              </div>
            </a-form-model-item>

            <div v-if="model.micro_promotion_type === 'AWEME'" class="short-video-link-scroll">
              <a-form-model-item label="平台" prop="platform_id" help="请选中端原生平台进行操作">
                <a-select allow-clear placeholder="平台" :default-value="model.platform_id" v-model="model.platform_id" show-search option-filter-prop="children" @change="changeNewPlatform" style="width: 260px;">
                  <a-select-option :value="platform.id" v-for="platform in newPlatforms" :key="platform.id" >
                      {{ platform.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>

              <a-form-model-item label="批量设置短剧专辑链接" :prop="batch_video_url">
                <div style="display: flex; align-items: center; gap: 8px; width: 100%">
                  <!-- <byted-select v-model="batch_video_url" transfer filterable clearable> -->
                  <byted-select v-model="batch_video_url" transfer filterable clearable :filter-method="handleSearchVideo" :loading="videoLoading">
                    <byted-option v-for="item in ptFenxiaos" :key="item.id" :value="item.link">
                      {{ item.video_name }}{{ item.video_id || item.link ? ' - ' + (item.video_id || item.link) : '' }}
                    </byted-option>
                  </byted-select>
                </div>
                <div style="margin-top: 8px;">
                  <span>可自定义链接，点击一键同步按钮，会自动将下面广告主【短剧专辑链接】选项填充。</span>
                  <a-button type="primary" size="small" @click="syncUrls(2)">
                    一键同步
                  </a-button>
                </div>
              </a-form-model-item>
            </div>

            <a-button
              v-if="model.micro_promotion_type === 'BYTE_APP' || model.micro_promotion_type === 'WECHAT_APP'"
              type="primary"
              size="small"
              :loading="syncLoading"
              @click="syncMultiple"
            >
              批量同步
            </a-button>

            <a-collapse default-active-key="1" :bordered="false" :accordion="true" class="short-video-advs-scroll">
              <a-collapse-panel :key="adv.id" :class="['custom-panel', tabClass(adv)]" v-for="adv in advs">
                <template #header>
                  <div style="display:flex; align-items:center; gap:8px;">
                    <a-checkbox
                      v-if="model.micro_promotion_type === 'BYTE_APP' || model.micro_promotion_type === 'WECHAT_APP'"
                      :checked="selectedAdvIds.includes(adv.id)"
                      @change="toggleSelect(adv.id)"
                      @click.stop
                    />
                    {{ adv.name }}
                  </div>
                </template>

                <template #extra>
                  <div style="display: flex; align-items: center; gap: 8px;" @click.stop>
                    <a-icon type="info-circle" />
                    <a-button
                      v-if="model.micro_promotion_type === 'BYTE_APP' || model.micro_promotion_type === 'WECHAT_APP'"
                      size="small"
                      type="primary"
                      @click.stop="syncData([adv.id])"
                    >
                      同步
                    </a-button>
                  </div>
                </template>

                <template v-if="model.micro_promotion_type === 'BYTE_APP'">
                  <a-form-model-item label="字节小程序" prop="adv.micro_app_instance_id">
                    <a-select show-search allow-clear placeholder="请选择" v-model="adv.micro_app_instance_id" option-filter-prop="children" @change="changeMicroApp(adv)">
                      <a-select-option :value="app.id" v-for="app in adv.apps" :key="app.id">
                        {{ app.name }}  - {{ app.id }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>

                  <a-form-model-item label="小程序链接" prop="adv.micro_app_url">
                    <a-select show-search placeholder="请选择" v-model="adv.micro_app_url" option-filter-prop="children">
                      <a-select-option :value="app.link" v-for="app in selectedAppLinks[adv.out_id]" :key="app.link">
                        【{{ app.name }}】{{ app.link }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>

                  <a-form-model-item label="备用网页链接(落地页)" help="可自定义链接">
                    <a-auto-complete
                    :dropdown-match-select-width="false"
                     placeholder="请选择或输入"
                     option-label-prop="value"
                      v-model="adv.external_url"
                    >
                    <template slot="dataSource">
                      <a-select-option 
                        v-for="url in externalUrls" :key="url" :value="url"  >
                        {{ url }}
                      </a-select-option>
                    </template>
                  </a-auto-complete>
                  </a-form-model-item>
                  
                  <a-form-model-item label="事件资产">
                    <a-select show-search allow-clear placeholder="请选择" v-model="adv.event_assets_id" option-filter-prop="children" @change="changeEventAssent(adv)">
                      <a-select-option :value="item.id" v-for="item in adv.event_assets" :key="item.id">
                        {{ item.name }} - {{ item.id }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </template>

                <template v-else-if="model.micro_promotion_type === 'AWEME'">
                  <a-form-model-item label="短剧专辑链接" help="可自定义链接">
                    <byted-select v-model="adv.video_url" transfer filterable clearable :filter-method="handleSearchVideo" :loading="videoLoading">
                        <byted-option v-for="item in ptFenxiaos" :key="item.id" :value="item.link">
                          {{ item.video_name }}{{ item.video_id || item.link ? ' - ' + (item.video_id || item.link) : '' }}
                        </byted-option>
                    </byted-select>
                  </a-form-model-item>
                </template>

                <template v-else> 
                  <a-form-model-item label="原生锚点" v-if="model.ad.native_setting.anchor_related_type == 'SELECT'" v-show="false">
                    <a-select show-search allow-clear placeholder="请选择" v-model="adv.anchor_id" option-filter-prop="children">
                      <a-select-option :value="anchor.id" v-for="anchor in adv.anchors" :key="anchor.id">
                        {{ anchor.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
    
                  <a-form-model-item label="落地页">
                    <a-select show-search allow-clear placeholder="请选择" v-model="adv.external_url" option-filter-prop="children">
                      <a-select-option :value="url.url" v-for="url in adv.external_urls" :key="url.id">
                        {{ url.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </template>
              </a-collapse-panel>
            </a-collapse>
          </div>
        </div>

        <!-- 结果页：保留 -->
        <div class="step" v-if="current === 3">
          <a-result
            status="success"
            title="提交成功"
            sub-title="该任务为异步执行，请稍后在任务列表中查看状态"
          >
            <template #extra>
              <a-button :loading="loading" :disabled="loading" @click="close">
                {{ loading ? '任务执行中' : '确认并关闭' }}
              </a-button>
              <a-button type="primary" :loading="loading" :disabled="loading" @click="jumpFirst">
                继续创建
             </a-button>
            </template>
          </a-result>
        </div>

        <!-- 按钮区域：隐藏上一步/下一步，保留核心按钮 -->
        <div class="steps-action">
          <a-space class="button-group">
            <a-button @click="close">取消</a-button>
            <a-button :loading="syncLoading" @click="syncData" v-if="model.micro_promotion_type !== 'AWEME'">
              <span v-if="model.micro_promotion_type === 'BYTE_APP'">同步小程序-事件资产-落地页</span>
              <span v-else>同步锚点-落地页-小程序</span>
            </a-button>
            <a-button type="primary" @click="submit">提交</a-button>

            <template v-if="current === steps.length - 1">
              <a-button :loading="loading" :disabled="loading" @click="close">
                {{ loading ? '任务执行中' : '确认并关闭' }}
              </a-button>
            </template>
          </a-space>
          <a-modal
            title="本地文案"
            :visible="visible"
            :confirm-loading="confirmLoading"
            @cancel="handleCancel"
            :footer="null"
            :width="1200"
            :body-style="{ maxHeight: 'none' }"
          >
            <div class="title-group-page">
              <title-group />
            </div>
          </a-modal>
        </div>
      </a-form-model>
    </a-drawer>
  </div>
</template>
<style lang="less" scoped>
@import 'Create';
</style>

<script>
import Create from './Create'
export default Create
</script>